/**
 * Default template for inbasket
 * Includes all mails and default variables
 */

import type { InbasketTemplateConfig } from "./types";

export const defaultTemplate: InbasketTemplateConfig = {
  id: "default",
  name: "Template par défaut",
  dureeConseillee: 120,
  mailKeys: [
    "achat_chaudiere",
    "appel_personnel",
    "confirmation_date_de_reunion_Plastitoc",
    "conges_a_venir",
    "contrats_de_vente",
    "demande_conges",
    "demande_formation_licence_professionnelle_rh",
    "dematerialisation_documentation_technique",
    "devis_construction_atelier_production",
    "extension_de_l_atelier_de_production",
    "horaires_monsieur_murat",
    "invitation_conference_grgu_Nancy",
    "journee_management_distance",
    "le_teletravail_ca_a_des_limites",
    "litige_societe_relax",
    "mega_concert",
    "mise_en_place_demarche_rse",
    "offre_abonnement_echos",
    "preparation_point_visio",
    "projet_demarche_rse",
    "projet_e_sytel",
    "projet_informatique",
    "projet_rse",
    "refus_dematerialisation_documentation_technique",
    "renouvellement_abonnement",
    "retard_structure_atelier_de_production",
    "situation_plus_que_critique",
    "systeme_securite_informatique_passoire",
    "teletravail_service_administratif",
    "urgent_erreur_de_livraison",
  ],
  mailTypeReponses: {
    "achat_chaudiere": "list",
    "appel_personnel": "list",
    "confirmation_date_de_reunion_Plastitoc": "list",
    "conges_a_venir": "no_response",
    "contrats_de_vente": "no_response",
    "demande_conges": "list",
    "demande_formation_licence_professionnelle_rh": "list",
    "dematerialisation_documentation_technique": "no_response",
    "devis_construction_atelier_production": "no_response",
    "extension_de_l_atelier_de_production": "no_response",
    "horaires_monsieur_murat": "list",
    "invitation_conference_grgu_Nancy": "no_response",
    "journee_management_distance": "list",
    "le_teletravail_ca_a_des_limites": "list",
    "litige_societe_relax": "no_response",
    "mega_concert": "mail",
    "mise_en_place_demarche_rse": "no_response",
    "offre_abonnement_echos": "list",
    "preparation_point_visio": "mail",
    "projet_demarche_rse": "list",
    "projet_e_sytel": "list",
    "projet_informatique": "mail",
    "projet_rse": "no_response",
    "refus_dematerialisation_documentation_technique": "no_response",
    "renouvellement_abonnement": "no_response",
    "retard_structure_atelier_de_production": "list",
    "situation_plus_que_critique": "list",
    "systeme_securite_informatique_passoire": "list",
    "teletravail_service_administratif": "no_response",
    "urgent_erreur_de_livraison": "no_response",
  },
  variablesData: {
    "genre_masc_abrege": "M.",
    "genre_masc_complet": "Monsieur",
    "genre_fem_abrege": "Mme.",
    "genre_fem_complet": "Madame",
    "societe_mere_nom": "SYTEL",
    "societe_nom": "SYTEL GRAND EST",
    "sytel_grand_est_logo": "/logos/sytel_grand_est.png",
    "plastitoc_logo": "/logos/plastitoc.png",
    "demos_logo": "/logos/demos.png",
    "les_echos_logo": "/logos/les_echos.png",
    "cci_logo": "/logos/cci.png",
    "lecco_logo": "/logos/lecco.png",
    "vice_president_administration_generale_genre": "masc",
    "vice_president_administration_generale_nom": "CORTE",
    "vice_president_administration_generale_prenom": "Yves",
    "vice_president_administration_generale_fonction": "Vice-Président Chargé de l'Administration Générale",
    "vice_president_administration_generale_societe": "SYTEL",
    "vice_president_charge_developpement_genre": "masc",
    "vice_president_charge_developpement_nom": "LAROCHE",
    "vice_president_charge_developpement_prenom": "Jean",
    "vice_president_charge_developpement_fonction": "Vice-Président Chargé du Développement",
    "vice_president_charge_developpement_societe": "SYTEL",
    "presidente_CA_genre": "fem",
    "presidente_CA_nom": "BRETON",
    "presidente_CA_prenom": "Lucie",
    "presidente_CA_fonction": "Présidente",
    "presidente_CA_societe": "SYTEL GRAND EST",
    "directeur_general_genre": "masc",
    "directeur_general_nom": "FRANCOIS",
    "directeur_general_prenom": "Pierre",
    "directeur_general_fonction": "Directeur Général",
    "directeur_general_societe": "SYTEL",
    "responsable_grand_est_precedent_genre": "masc",
    "responsable_grand_est_precedent_nom": "SOL",
    "responsable_grand_est_precedent_prenom": "Gerard",
    "responsable_grand_est_precedent_fonction": "Directeur régional",
    "responsable_grand_est_precedent_fonction_organigramme": "Responsable de la société",
    "responsable_grand_est_precedent_societe": "SYTEL GRAND EST",
    "responsable_grand_est_actuel_genre": "masc",
    "responsable_grand_est_actuel_nom": "MAS",
    "responsable_grand_est_actuel_prenom": "Julien",
    "responsable_grand_est_actuel_fonction": "Responsable",
    "responsable_grand_est_actuel_societe": "SYTEL France",
    "secretaire_genre": "fem",
    "secretaire_nom": "SON",
    "secretaire_prenom": "Nicole",
    "secretaire_fonction": "Assistante de Direction",
    "secretaire_societe": "SYTEL France",
    "secretaire_date_debut_conges": "2",
    "secretaire_date_fin_conges": "10",
    "responsable_commercial_genre": "fem",
    "responsable_commercial_nom": "SEBAG",
    "responsable_commercial_prenom": "Leïla",
    "responsable_commercial_fonction": "Responsable du service Commercial",
    "responsable_commercial_societe": "SYTEL GRAND EST",
    "responsable_commercial_date_debut_conges": "27",
    "responsable_commercial_date_fin_conges": "35",
    "responsable_administration_genre": "masc",
    "responsable_administration_nom": "AS",
    "responsable_administration_prenom": "François",
    "responsable_administration_fonction": "Responsable du service administratif",
    "responsable_administration_societe": "SYTEL GRAND EST",
    "administration_personnel_accueil_genre": "masc",
    "administration_personnel_accueil_nom": "DELACOURT",
    "administration_personnel_accueil_prenom": "Gilles",
    "administration_personnel_accueil_fonction": "Responsable du Personnel et de l'Accueil - Service du Personnel",
    "administration_personnel_accueil_societe": "SYTEL GRAND EST",
    "administration_comptabilite_genre": "",
    "administration_comptabilite_nom": "GAUTHIER",
    "administration_comptabilite_prenom": "L.",
    "administration_comptabilite_fonction": "Comptabilité",
    "administration_comptabilite_societe": "SYTEL GRAND EST",
    "administration_informatique_genre": "fem",
    "administration_informatique_nom": "STOVANOVIC",
    "administration_informatique_prenom": "Marie-France",
    "administration_informatique_fonction": "Responsable Informatique",
    "administration_informatique_societe": "SYTEL GRAND EST",
    "etudes_et_procedes_genre": "masc",
    "etudes_et_procedes_nom": "VILLENEUVE",
    "etudes_et_procedes_prenom": "Robert",
    "etudes_et_procedes_fonction": "Responsable Etudes et Procédés",
    "etudes_et_procedes_societe": "SYTEL GRAND EST",
    "responsable_production_genre": "masc",
    "responsable_production_nom": "LEBLANC",
    "responsable_production_prenom": "Claude",
    "responsable_production_fonction": "Responsable Production",
    "responsable_production_societe": "SYTEL GRAND EST",
    "production_achats_genre": "",
    "production_achats_nom": "L'HOSTE",
    "production_achats_prenom": "B.",
    "production_achats_fonction": "Achats",
    "production_achats_societe": "SYTEL GRAND EST",
    "production_logistique_genre": "",
    "production_logistique_nom": "ZAVADJIAN",
    "production_logistique_prenom": "S.",
    "production_logistique_fonction": "Logistique",
    "production_logistique_societe": "SYTEL GRAND EST",
    "production_fabrication_genre": "",
    "production_fabrication_nom": "ANGELIL",
    "production_fabrication_prenom": "T.",
    "production_fabrication_fonction": "Fabrication",
    "production_fabrication_societe": "SYTEL GRAND EST",
    "entretien_et_securite_genre": "masc",
    "entretien_et_securite_nom": "PAX",
    "entretien_et_securite_prenom": "Michel",
    "entretien_et_securite_fonction": "Responsable Entretien et Sécurité",
    "entretien_et_securite_societe": "SYTEL GRAND EST",
    "employe_service_du_personnel_genre": "masc",
    "employe_service_du_personnel_nom": "MURAT",
    "employe_service_du_personnel_prenom": "",
    "employe_service_du_personnel_societe": "SYTEL GRAND EST",
    "collaborateur_1_genre": "masc",
    "collaborateur_1_nom": "MIL",
    "collaborateur_1_prenom": "Frédérique",
    "collaborateur_1_fonction": "Département Administratif",
    "collaborateur_1_societe": "SYTEL GRAND EST",
    "collaborateur_1_date_debut_conges": "15",
    "collaborateur_1_date_fin_conges": "21",
    "syndicat_nom": "ITEP",
    "delegue_syndical_genre": "masc",
    "delegue_syndical_nom": "STREIFF",
    "delegue_syndical_prenom": "",
    "delegue_syndical_societe": "SYTEL GRAND EST",
    "cadre_technico_commercial_genre": "masc",
    "cadre_technico_commercial_nom": "BART",
    "cadre_technico_commercial_prenom": "",
    "cadre_technico_commercial_fonction": "cadre technico-commercial",
    "cadre_technico_commercial_societe": "SYTEL GRAND EST",
    "employe_administratif_genre": "masc",
    "employe_administratif_nom": "FRIN",
    "employe_administratif_prenom": "Didier",
    "employe_administratif_fonction": "Employé administratif - Service du Personnel",
    "employe_administratif_societe": "SYTEL Grand Est",
    "employe_informatique_1_genre": "fem",
    "employe_informatique_1_nom": "BAUDRY",
    "employe_informatique_1_prenom": "Juliette",
    "employe_informatique_1_societe": "SYTEL GRAND EST",
    "employe_informatique_2_genre": "masc",
    "employe_informatique_2_nom": "MIL",
    "employe_informatique_2_prenom": "François",
    "employe_informatique_2_societe": "SYTEL GRAND EST",
    "employe_informatique_3_genre": "fem",
    "employe_informatique_3_nom": "VALLEE",
    "employe_informatique_3_prenom": "Alix",
    "employe_informatique_3_societe": "SYTEL GRAND EST",
    "erreur_livraison_societe": "RELAX",
    "erreur_livraison_societe_directeur_achat_genre": "masc",
    "erreur_livraison_societe_directeur_achat_nom": "BODIN",
    "erreur_livraison_societe_directeur_achat_prenom": "Jean",
    "erreur_livraison_societe_directeur_achat_fonction": "Directeur Achat",
    "erreur_livraison_date_livraison": "-6",
    "livraison_atelier_production_date_prevue": "31",
    "livraison_atelier_production_date_avec_retard": "51",
    "plastitoc_rdv_date": "14",
    "plastitoc_societe": "PLASTITOC",
    "plastitioc_directeur_general_genre": "masc",
    "plastitioc_directeur_general_nom": "Bertrand",
    "plastitioc_directeur_general_prenom": "Jean",
    "plastitioc_directeur_general_fonction": "Directeur Général",
    "plastitioc_directeur_general_societe": "PLASTITOC",
    "societe_a_livrer_societe": "SCHLUMBER",
    "societe_a_livrer_date_livraison": "42",
    "conference_grgu_date": "15",
    "conference_grgu_conferencier_genre": "masc",
    "conference_grgu_conferencier_nom": "BONNET",
    "conference_grgu_conferencier_prenom": "Yannick",
    "conference_grgu_conferencier_fonction": "Président de l'Institut de Développement Ethique, Scientifique et Social",
    "conference_grgu_conferencier_societe": "Université",
    "conference_grgu_emetteur_invitation_genre": "fem",
    "conference_grgu_emetteur_invitation_nom": "LABORIE",
    "conference_grgu_emetteur_invitation_prenom": "Francine",
    "conference_grgu_emetteur_invitation_mail": "francine.laborie@universite.fr",
    "conference_cci_date": "12",
    "cci_responsable_formation_genre": "masc",
    "cci_responsable_formation_nom": "Berger",
    "cci_responsable_formation_prenom": "Mathieu",
    "cci_responsable_formation_fonction": "Responsable Formation",
    "cci_responsable_formation_societe": "Chambre du Commerce et de l'Industrie",
    "invitation_concert_genre": "masc",
    "invitation_concert_nom": "Vrigny",
    "invitation_concert_prenom": "Alexandre",
    "echos_directeur_ventes_genre": "masc",
    "echos_directeur_ventes_nom": "PALIN",
    "echos_directeur_ventes_prenom": "Jean",
    "echos_directeur_ventes_fonction": "Directeur des Ventes",
    "echos_directeur_ventes_societe": "Les Echos",
    "lecco_gerant_genre": "masc",
    "lecco_gerant_nom": "COEUR",
    "lecco_gerant_prenom": "Roger",
    "lecco_gerant_fonction": "Gérant",
    "lecco_gerant_societe": "LECCO Construction",
    "pirates_informatiques_emetteur_genre": "masc",
    "pirates_informatiques_emetteur_nom": "MORICONE",
    "pirates_informatiques_emetteur_prenom": "J.M.",
    "pirates_informatiques_emetteur_fonction": "Intrusions Senior Manager",
    "pirates_informatiques_emetteur_societe": "Pirate&Co",
    "la_vie_francaise_directeur_general_genre": "masc",
    "la_vie_francaise_directeur_general_nom": "THEVENOT",
    "la_vie_francaise_directeur_general_prenom": "Gilbert",
    "la_vie_francaise_directeur_general_fonction": "Directeur Général",
    "la_vie_francaise_directeur_general_societe": "LA VIE FRANCAISE",
    "demos_directeur_genre": "masc",
    "demos_directeur_nom": "SENS",
    "demos_directeur_prenom": "Jean Louis",
    "demos_directeur_fonction": "Directeur",
    "demos_directeur_societe": "Demos",
    "cle_dernier_mail": "preparation_point_visio"
  },
};
